import { stylesAcces } from './acces.tsx'
import { stylesEvenements } from './evenements.tsx'
import { CSS_BRAND_ADMIN } from './brand.ts'
import { CSS_DEMO_EASTER_EGG } from './demo-easter-egg-styles.ts'
export const CSS_ADMIN = `
:root {
  color-scheme: light;
  --admin-encre: #2a1632;
  --admin-doux: #6b5a70;
  --admin-fond: #f9f6fa;
  --admin-ligne: #e8e2ea;
  --admin-primaire: #391d44;
  --admin-fonce: #2a1632;
  --admin-accent: #f4eef6;
}
* {
  box-sizing: border-box;
}
body {
  margin: 0;
  background: var(--admin-fond);
  color: var(--admin-encre);
  font:
    14px/1.5 -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
}
button,
input,
select,
textarea {
  font: inherit;
}
button,
a,
input,
select,
textarea {
  -webkit-tap-highlight-color: transparent;
}
button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 7px;
  padding: 0.65rem 0.95rem;
  min-height: 42px;
  font-weight: 550;
}
button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}
svg {
  flex-shrink: 0;
}
a {
  color: var(--admin-primaire);
  text-underline-offset: 3px;
}
button:focus-visible,
a:focus-visible,
summary:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible,
[tabindex]:focus-visible {
  outline: 3px solid #9a88a1;
  outline-offset: 3px;
}
h1,
h2,
h3,
p {
  margin-top: 0;
}
h2 {
  font-size: 1.1rem;
  font-weight: 650;
  letter-spacing: -0.02em;
}
h3 {
  font-size: 0.95rem;
  font-weight: 600;
}
p {
  color: var(--admin-doux);
}
[hidden] {
  display: none !important;
}
.admin {
  min-height: 100vh;
  display: grid;
  grid-template-columns: 246px minmax(0, 1fr);
}
.admin__lateral {
  position: sticky;
  top: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 30px 18px 18px;
  background: #fff;
  border-right: 1px solid var(--admin-ligne);
}
.admin__marque {
  display: flex;
  align-items: center;
  gap: 11px;
  text-decoration: none;
  margin: 0 12px 30px;
  color: var(--admin-encre);
}
.admin__logo {
  font-size: 39px;
  font-family: Georgia, serif;
  line-height: 1;
  font-weight: bold;
  letter-spacing: -0.12em;
  color: var(--admin-primaire);
}
.admin__logo > span {
  color: #9da66b;
}
.admin__marque > strong {
  font-size: 25px;
  letter-spacing: -1px;
  line-height: 1.15;
}
.admin__marque strong > span {
  display: block;
  font-size: 9px;
  letter-spacing: 0.2px;
  color: var(--admin-doux);
  font-weight: 400;
  margin-top: 5px;
}
.admin__organisation {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--admin-fond);
  border: 1px solid var(--admin-ligne);
  border-radius: 8px;
  padding: 12px 10px;
  margin-bottom: 27px;
  min-width: 0;
}
.admin__organisation > div {
  min-width: 0;
}
.admin__organisation strong {
  display: block;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.admin__organisation span:not(.admin__avatar) {
  display: block;
  font-size: 11px;
  color: var(--admin-doux);
}
.admin__avatar {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid #e1d9e4;
  background: #f0e9f4;
  color: #391d44;
  font-weight: 600;
  border-radius: 8px;
}
.admin__avatar--petit {
  height: 29px;
  width: 29px;
  font-size: 12px;
  border-radius: 50%;
}
.admin__surtitre {
  font-size: 10px;
  font-weight: 650;
  letter-spacing: 1.4px;
  color: #6b5a70;
}
.admin__menu-label {
  padding: 0 12px;
  margin-bottom: 10px;
}
.admin__navigation {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.admin__navigation button {
  width: 100%;
  text-align: left;
  justify-content: flex-start;
  padding: 11px 12px;
  font-size: 12px;
  background: transparent;
  color: #7b6783;
  min-height: 44px;
  font-weight: 500;
}
.admin__navigation button:hover {
  background: #f9f6fa;
}
.admin__navigation button[aria-current="page"] {
  background: #f4eef6;
  color: #391d44;
  font-weight: 650;
}
.admin__navigation button svg {
  width: 18px;
  height: 18px;
  margin-right: 2px;
}
.admin__compteur {
  margin-left: auto;
  background: #e9dff0;
  color: #391d44;
  font-size: 10px;
  border-radius: 4px;
  min-width: 20px;
  padding: 1px 5px;
  text-align: center;
}
.admin__compteur--neutre {
  background: #f4eff7;
  color: #836e8c;
}
.admin__aide {
  margin: auto 3px 20px;
  padding: 17px 12px 4px;
  border-top: 1px solid var(--admin-ligne);
}
.admin__aide > svg {
  color: #6b5a70;
  margin-bottom: 9px;
}
.admin__aide strong {
  font-size: 11px;
  display: block;
}
.admin__aide p {
  font-size: 11px;
  line-height: 1.6;
  margin: 5px 0 9px;
}
.admin__aide button {
  padding: 0;
  min-height: 30px;
  background: none;
  color: var(--admin-primaire);
  font-size: 11px;
  justify-content: flex-start;
}
.admin__pied-lateral {
  display: flex;
  gap: 7px;
  align-items: center;
  font-size: 9px;
  color: var(--admin-doux);
  white-space: nowrap;
}
.admin__point {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #8b7693;
  flex-shrink: 0;
}
.admin__point--attente {
  background: #a5843e;
}
.admin__espace {
  min-width: 0;
}
.admin__barre {
  height: 73px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  border-bottom: 1px solid var(--admin-ligne);
  background: #fff;
}
.admin__barre > span {
  font-size: 10px;
  color: #6b5a70;
  letter-spacing: 0.75px;
}
.admin__barre strong {
  font-weight: 500;
  letter-spacing: 0;
  color: #705e78;
  font-size: 11px;
}
.admin__separateur {
  margin: 0 14px;
  color: #6b5a70;
}
.admin__outils {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--admin-doux);
  font-size: 11px;
}
.admin__contenu {
  padding: 35px 40px 0;
  max-width: 1500px;
  margin: auto;
  min-width: 0;
}
.admin__entete {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
}
.admin__entete .admin__surtitre {
  margin-bottom: 8px;
}
h1 {
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -1.1px;
  margin: 0 0 6px;
  line-height: 1.3;
}
.admin__entete p:last-child {
  font-size: 12px;
  margin-bottom: 0;
}
.admin__entete > button {
  font-size: 12px;
  flex-shrink: 0;
}
.admin__primaire {
  background: var(--admin-primaire);
  color: #fff;
  box-shadow: 0 1px 2px #2a16320a;
}
.admin__primaire:hover:not(:disabled) {
  background: var(--admin-fonce);
}
.admin__secondaire {
  background: #fff;
  border-color: var(--admin-ligne);
  color: var(--admin-encre);
}
.admin__secondaire:hover:not(:disabled) {
  background: #f9f5fa;
  border-color: #cabdcf;
}
.admin__danger {
  background: #fff8f5;
  border-color: #e7c8bf;
  color: #9b382d;
}
.admin__texte-bouton {
  background: transparent;
  color: var(--admin-primaire);
  padding: 4px 0;
  font-size: 12px;
}
.admin__mode {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px 14px;
  background: #f5eff7;
  border: 1px solid #e7e4d7;
  border-radius: 7px;
  font-size: 11px;
  color: #7c7051;
  margin-bottom: 22px;
}
.admin__mode strong {
  font-weight: 600;
  color: #786b43;
}
.admin__mode button {
  margin-left: auto;
  padding: 0 0 0 10px;
  min-height: 24px;
  background: transparent;
  font-size: 11px;
  color: #736241;
}
.admin__stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin-bottom: 25px;
}
.admin__stat {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: left;
  background: #fff;
  border: 1px solid var(--admin-ligne);
  border-radius: 9px;
  padding: 20px 22px;
  gap: 0;
  color: inherit;
  min-width: 0;
}
.admin__stat-titre {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: #826d8b;
}
.admin__stat-titre svg {
  color: #6b5a70;
  width: 18px;
  height: 18px;
}
.admin__stat > strong {
  font-size: 35px;
  line-height: 1.5;
  font-weight: 550;
  letter-spacing: -1.5px;
  margin: 3px 0;
}
.admin__stat small {
  font-size: 10px;
  color: #7b6783;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}
.admin__stat small svg {
  color: var(--admin-primaire);
}
button.admin__stat:hover {
  border-color: #a999af;
  background: #fcfdf9;
}
.admin__accueil-grille {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 290px;
  gap: 22px;
  margin-bottom: 25px;
}
.admin__panneau {
  min-width: 0;
  background: #fff;
  border: 1px solid var(--admin-ligne);
  border-radius: 9px;
  overflow: hidden;
}
.admin__section-entete {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 22px;
  border-bottom: 1px solid #f3edf6;
}
.admin__section-entete h2 {
  margin: 0 0 4px;
  font-size: 15px;
}
.admin__section-entete p {
  margin: 0;
  font-size: 11px;
}
.admin__pastille {
  padding: 2px 8px;
  background: #f7f3f9;
  font-size: 11px;
  color: #6b5a70;
  border-radius: 5px;
}
.admin__services {
  padding: 0 22px;
}
.admin__service {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 21px 0;
}
.admin__service + .admin__service {
  border-top: 1px solid #f3edf6;
}
.admin__icone-service {
  display: inline-flex;
  width: 44px;
  height: 44px;
  border: 1px solid #e7dde9;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f3f6ec;
  color: #6b5a70;
  flex-shrink: 0;
}
.admin__service-info {
  flex: 1;
  min-width: 0;
}
.admin__service-info h3 {
  font-size: 13px;
  line-height: 1.5;
  margin: 0 0 6px;
}
.admin__service-info > small {
  display: block;
  font-size: 10px;
  color: #6b5a70;
  margin-top: 5px;
}
.admin__service .admin__actions {
  gap: 8px;
}
.admin__service .admin__secondaire {
  padding: 6px 10px;
  min-height: 34px;
  font-size: 11px;
}
.admin__lien-icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  color: #6b5a70;
  min-width: 40px;
  min-height: 40px;
}
.admin__prochain {
  padding: 25px;
  background: #f2ecf5;
  border: 1px solid #e7dde9;
  border-radius: 9px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.admin__prochain > .admin__surtitre {
  font-size: 9px;
  color: #6b5a70;
}
.admin__prochain > svg {
  margin: 21px 0 17px;
  color: #6b5a70;
}
.admin__prochain h2 {
  font-size: 21px;
  letter-spacing: -0.55px;
  line-height: 1.25;
  margin-bottom: 11px;
  max-width: 210px;
}
.admin__prochain p {
  font-size: 11px;
  line-height: 1.7;
  color: #6b5a70;
  margin-bottom: 20px;
}
.admin__prochain button {
  font-size: 11px;
  min-height: 37px;
  padding: 8px 11px;
  margin-top: auto;
}
.admin__table-wrap {
  overflow-x: auto;
}
.admin__table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 12px;
}
.admin__table th {
  font-size: 9px;
  letter-spacing: 0.65px;
  text-transform: uppercase;
  font-weight: 600;
  color: #7b6783;
  background: #fcfafc;
  padding: 12px 22px;
  white-space: nowrap;
}
.admin__table td {
  padding: 17px 22px;
  border-top: 1px solid #f3edf6;
  vertical-align: middle;
}
.admin__table strong {
  font-weight: 550;
  font-size: 12px;
  display: block;
}
.admin__table small {
  display: block;
  font-size: 11px;
  color: #7b6783;
  line-height: 1.6;
  margin-top: 3px;
  overflow-wrap: anywhere;
}
.admin__table .admin__actions button {
  font-size: 11px;
  min-height: 34px;
  padding: 5px 9px;
}
.admin__table tbody tr:hover {
  background: #fcfdf9;
}
.admin__etat {
  display: inline-flex;
  gap: 5px;
  align-items: center;
  font-size: 10px;
  line-height: 1.6;
  padding: 3px 8px;
  background: #f5eff7;
  color: #6b5a70;
  border-radius: 5px;
  white-space: nowrap;
}
.admin__etat::before {
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
}
.admin__etat--confirmee {
  color: #4e7649;
  background: #f5f0f7;
}
.admin__etat--en_attente_approbation,
.admin__etat--en_attente_paiement {
  background: #fbf2e1;
  color: #92773a;
}
.admin__etat--refusee {
  background: #fbefeb;
  color: #a36450;
}
.admin__etat--annulee,
.admin__etat--expiree {
  background: #f4eff7;
  color: #6b5a70;
}
.admin__section {
  padding: 24px;
}
.admin__section > p {
  max-width: 70ch;
  font-size: 13px;
}
.admin__section > :last-child {
  margin-bottom: 0;
}
.admin__note {
  font-size: 11px;
  color: #6b5a70;
}
.admin__grille {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 300px), 1fr));
  gap: 18px;
}
.admin__carte {
  padding: 21px;
  border: 1px solid var(--admin-ligne);
  border-radius: 8px;
  background: #fff;
  min-width: 0;
}
.admin__carte > h3 {
  margin-top: 0;
}
.admin__carte--consigne h2 {
  margin-top: 15px;
}
.admin__carte p,
.admin__etapes {
  font-size: 12px;
  line-height: 1.7;
}
.admin__etapes {
  padding-left: 20px;
  color: var(--admin-doux);
}
.admin__etapes li {
  padding-left: 4px;
  margin: 10px 0;
}
.admin__code {
  background: #f9f5fa;
  padding: 16px;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font-size: 11px;
  max-width: 100%;
  border-radius: 6px;
}
.admin__code code {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}
.admin__actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.admin__actions > a {
  font-size: 12px;
  display: inline-flex;
  gap: 6px;
  align-items: center;
}
.admin__champ {
  display: grid;
  gap: 7px;
  min-width: 0;
}
.admin__champ label {
  font-size: 11px;
  font-weight: 550;
  color: #7a6682;
}
input,
select,
textarea {
  min-width: 0;
  border: 1px solid #e5dfe8;
  border-radius: 7px;
  padding: 11px 12px;
  background: #fff;
  color: var(--admin-encre);
  width: 100%;
  min-height: 44px;
}
textarea {
  resize: vertical;
  min-height: 90px;
}
.admin__filtres {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr;
  gap: 16px;
}
.admin__resultat-filtre {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 11px;
  color: var(--admin-doux);
  margin-top: 18px;
}
.admin__bienvenue-assistant {
  text-align: center;
  max-width: 620px;
  margin: 30px auto;
}
.admin__bienvenue-assistant > .admin__icone-service {
  margin-bottom: 21px;
  width: 56px;
  height: 56px;
}
.admin__bienvenue-assistant h2 {
  font-size: 24px;
  letter-spacing: -0.6px;
}
.admin__bienvenue-assistant p {
  line-height: 1.8;
  font-size: 13px;
}
.admin__suggestions {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 26px;
}
.admin__suggestions button {
  text-align: left;
  align-items: flex-start;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.7;
  padding: 16px;
  justify-content: space-between;
}
.admin__conversation {
  display: grid;
  grid-template-rows: minmax(350px, 1fr) auto;
  min-height: 550px;
}
.admin__fil {
  max-height: 65vh;
  min-height: 350px;
  overflow: auto;
  padding: 28px;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.admin__bulle {
  max-width: min(85%, 700px);
  padding: 15px 18px;
  border-radius: 10px;
  white-space: pre-wrap;
  line-height: 1.7;
  font-size: 13px;
}
.admin__bulle > strong {
  font-size: 10px;
  display: block;
  margin-bottom: 5px;
}
.admin__bulle--responsable {
  align-self: flex-end;
  background: var(--admin-primaire);
  color: #fff;
}
.admin__bulle--assistant {
  align-self: flex-start;
  background: #f6f1f8;
}
.admin__outil {
  font-size: 11px;
  color: var(--admin-doux);
}
.admin__compositeur {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: end;
  border-top: 1px solid var(--admin-ligne);
  padding: 18px;
  background: #fcfafc;
}
.admin__compositeur textarea {
  min-height: 64px;
  max-height: 180px;
}
.admin__compositeur button {
  height: 44px;
  margin-bottom: 10px;
}
.admin__section-entete--apercu {
  flex-wrap: wrap;
}
.admin__section-entete--apercu > .admin__champ {
  flex: 1;
  max-width: 420px;
  min-width: min(100%, 200px);
}
.admin__apercu {
  padding: 15px;
  background: #f3edf6;
}
.admin__apercu iframe {
  width: 100%;
  min-height: 700px;
  border: 1px solid var(--admin-ligne);
  border-radius: 8px;
  background: #fff;
  display: block;
  margin: auto;
}
.admin__apercu .admin__iframe--mobile {
  max-width: 390px;
}
.admin__formats {
  display: flex;
  gap: 5px;
  justify-content: center;
  margin-bottom: 15px;
}
.admin__formats button {
  font-size: 11px;
  min-height: 34px;
  background: transparent;
  color: #6b5a70;
}
.admin__formats button[aria-pressed="true"] {
  background: #fff;
  color: var(--admin-encre);
  border-color: var(--admin-ligne);
}
.admin__courriers {
  display: grid;
  gap: 12px;
}
.admin__courriers summary {
  cursor: pointer;
  min-height: 38px;
  font-size: 13px;
  overflow-wrap: anywhere;
}
.admin__courriers small {
  display: block;
  font-size: 11px;
  color: var(--admin-doux);
  margin-top: 5px;
}
.admin__courrier {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  margin-top: 20px;
}
.admin__vide {
  text-align: center;
  padding: 42px 22px;
}
.admin__vide .admin__icone-service {
  margin-bottom: 16px;
}
.admin__vide h3 {
  font-size: 15px;
  margin-bottom: 7px;
}
.admin__vide p {
  font-size: 12px;
  max-width: 400px;
  margin: 0 auto 18px;
}
.admin__pied {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  color: #7c6884;
  margin-top: 35px;
  padding: 20px 0;
  border-top: 1px solid var(--admin-ligne);
}
.admin__pied > span {
  font-size: 10px;
  color: #7c6884;
}
.admin__message {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 16px;
  border: 1px solid #e6c9bd;
  background: #fff5f0;
  border-radius: 7px;
  margin-bottom: 18px;
  font-size: 12px;
}
.admin__message--erreur {
  color: #994e38;
}
.admin__message button {
  font-size: 11px;
  min-height: 32px;
  background: #fff;
  color: inherit;
}
.admin__notification {
  position: fixed;
  right: 25px;
  bottom: 25px;
  z-index: 5;
  max-width: calc(100vw - 50px);
}
.admin__notification > span {
  display: flex;
  align-items: center;
  gap: 9px;
  background: #391d44;
  color: #fff;
  padding: 14px 20px;
  border-radius: 8px;
  box-shadow: 0 8px 25px #2a163220;
  font-size: 13px;
}
.admin__chargement {
  padding: 70px;
  text-align: center;
  color: var(--admin-doux);
}
.admin__dialogue {
  width: min(100% - 32px, 470px);
  padding: 28px;
  border: 1px solid var(--admin-ligne);
  border-radius: 12px;
  color: var(--admin-encre);
  box-shadow: 0 25px 70px #391d4430;
}
.admin__dialogue::backdrop {
  background: #2a163270;
}
.admin__dialogue p {
  font-size: 13px;
  line-height: 1.7;
}
.admin__dialogue .admin__actions {
  justify-content: flex-end;
  margin-top: 24px;
}
.admin__dialogue h2 {
  font-size: 21px;
}
.admin__evitement {
  position: fixed;
  top: 8px;
  left: 8px;
  z-index: 100;
  transform: translateY(-160%);
  padding: 12px;
  background: #fff;
  border: 2px solid var(--admin-primaire);
}
.admin__evitement:focus {
  transform: none;
}
.admin__visually-hidden {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.admin__connexion {
  max-width: 430px;
  margin: 10vh auto;
  background: #fff;
  border: 1px solid var(--admin-ligne);
  border-radius: 12px;
  padding: 32px;
}
.admin__connexion h1 {
  font-size: 25px;
}
.admin__connexion .admin__champ {
  margin: 24px 0 16px;
}
.admin__connexion p {
  font-size: 13px;
}
.admin__connexion form > button {
  width: 100%;
}
@media (min-width: 1600px) {
  .admin__contenu {
    padding-top: 44px;
  }
  .admin__service {
    padding-block: 28px;
  }
  .admin__prochain {
    padding: 30px;
  }
}
@media (max-width: 1150px) {
  .admin {
    grid-template-columns: 214px minmax(0, 1fr);
  }
  .admin__contenu {
    padding: 28px 24px 0;
  }
  .admin__barre {
    padding: 0 24px;
  }
  .admin__accueil-grille {
    grid-template-columns: minmax(0, 1fr) 235px;
    gap: 16px;
  }
  .admin__stats {
    gap: 12px;
  }
  .admin__stat {
    padding: 17px;
  }
  .admin__prochain {
    padding: 21px;
  }
  .admin__service {
    flex-wrap: wrap;
  }
  .admin__service > .admin__actions {
    margin-left: 57px;
  }
  .admin__pied-lateral {
    font-size: 10px;
  }
  .admin__lateral {
    padding-inline: 13px;
  }
}
@media (max-width: 850px) {
  .admin {
    grid-template-columns: 1fr;
  }
  .admin__lateral {
    position: static;
    height: auto;
    padding: 14px 20px 0;
    border-right: 0;
    border-bottom: 1px solid var(--admin-ligne);
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
  }
  .admin__marque {
    margin: 0;
  }
  .admin__organisation {
    margin: 0;
    justify-self: end;
    padding: 7px 10px;
    max-width: 230px;
  }
  .admin__organisation .admin__avatar {
    width: 27px;
    height: 27px;
  }
  .admin__navigation {
    grid-column: 1/-1;
    flex-direction: row;
    overflow: auto;
    gap: 4px;
    margin: 13px -8px 0;
    padding-bottom: 10px;
  }
  .admin__navigation button {
    width: auto;
    white-space: nowrap;
    font-size: 11px;
    padding: 8px 11px;
    min-height: 40px;
  }
  .admin__navigation button svg {
    width: 16px;
  }
  .admin__menu-label,
  .admin__aide,
  .admin__pied-lateral,
  .admin__barre {
    display: none;
  }
  .admin__accueil-grille {
    grid-template-columns: minmax(0, 1fr) 250px;
  }
  .admin__contenu {
    padding: 26px 20px 0;
  }
  .admin__entete h1 {
    font-size: 28px;
  }
  .admin__filtres {
    grid-template-columns: 1fr 1fr;
  }
  .admin__filtres > .admin__champ:first-child {
    grid-column: 1/-1;
  }
}
@media (max-width: 600px) {
  .admin__lateral {
    padding: 12px 14px 0;
  }
  .admin__marque strong {
    font-size: 21px;
  }
  .admin__logo {
    font-size: 34px;
  }
  .admin__marque strong > span {
    font-size: 10px;
  }
  .admin__organisation {
    max-width: 170px;
    background: none;
    border: 0;
    padding: 0;
  }
  .admin__organisation strong {
    font-size: 10px;
  }
  .admin__organisation span:not(.admin__avatar) {
    font-size: 9px;
  }
  .admin__contenu {
    padding: 24px 15px 0;
  }
  .admin__entete {
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 20px;
  }
  .admin__entete > button {
    min-height: 39px;
    font-size: 11px;
  }
  .admin__entete .admin__surtitre {
    font-size: 9px;
  }
  .admin__entete p:last-child {
    font-size: 12px;
    max-width: 32ch;
  }
  .admin__mode {
    flex-wrap: wrap;
    gap: 7px;
    font-size: 10px;
    padding: 10px 12px;
  }
  .admin__mode button {
    margin-left: 0;
    padding-left: 0;
  }
  .admin__stats {
    gap: 8px;
    margin-bottom: 17px;
  }
  .admin__stat {
    padding: 12px 10px;
  }
  .admin__stat-titre {
    font-size: 10px;
    min-height: 30px;
    align-items: flex-start;
  }
  .admin__stat-titre svg {
    display: none;
  }
  .admin__stat > strong {
    font-size: 28px;
    margin: 0;
  }
  .admin__stat small {
    font-size: 10px;
    line-height: 1.5;
  }
  .admin__stat small svg {
    display: none;
  }
  .admin__accueil-grille {
    grid-template-columns: 1fr;
    gap: 17px;
    margin-bottom: 17px;
  }
  .admin__prochain {
    padding: 20px;
    display: block;
  }
  .admin__prochain > .admin__surtitre {
    display: block;
  }
  .admin__prochain > svg {
    float: right;
    margin: 15px 0 0;
  }
  .admin__prochain h2 {
    max-width: none;
    margin: 15px 0 10px;
    font-size: 20px;
  }
  .admin__prochain p {
    max-width: 43ch;
    margin-bottom: 15px;
  }
  .admin__section-entete {
    padding: 17px;
  }
  .admin__services {
    padding: 0 17px;
  }
  .admin__service {
    gap: 10px;
    padding: 17px 0;
  }
  .admin__service > .admin__actions {
    margin-left: 0;
  }
  .admin__service-info h3 {
    font-size: 12px;
  }
  .admin__service .admin__lien-icone {
    display: none;
  }
  .admin__service > .admin__icone-service {
    width: 37px;
    height: 37px;
  }
  .admin__service .admin__secondaire {
    font-size: 10px;
    padding: 6px;
  }
  .admin__table th,
  .admin__table td {
    padding: 12px 14px;
  }
  .admin__table {
    min-width: 480px;
  }
  .admin__table strong {
    font-size: 11px;
  }
  .admin__section {
    padding: 18px;
  }
  .admin__grille {
    gap: 14px;
  }
  .admin__filtres {
    gap: 12px;
  }
  .admin__filtres input,
  .admin__filtres select {
    font-size: 16px;
    padding: 9px;
    min-height: 44px;
  }
  .admin__resultat-filtre {
    align-items: flex-start;
    flex-direction: column;
  }
  .admin__suggestions {
    grid-template-columns: 1fr;
  }
  .admin__fil {
    padding: 20px;
    min-height: 330px;
  }
  .admin__bienvenue-assistant {
    margin: 12px auto;
  }
  .admin__bienvenue-assistant h2 {
    font-size: 20px;
  }
  .admin__compositeur {
    padding: 12px;
    grid-template-columns: 1fr;
  }
  .admin__compositeur textarea {
    font-size: 16px;
  }
  .admin__compositeur button {
    justify-self: end;
    margin: 0;
  }
  .admin__bulle {
    max-width: 95%;
  }
  .admin__pied {
    font-size: 10px;
  }
  .admin__pied > span {
    font-size: 10px;
  }
  .admin__section-entete--apercu .admin__actions {
    width: 100%;
  }
  .admin__section-entete--apercu button {
    font-size: 11px;
  }
  .admin__apercu {
    padding: 8px;
  }
  .admin__connexion {
    margin: 6vh 16px;
    padding: 25px;
  }
  .admin__dialogue textarea {
    font-size: 16px;
  }
}
.admin__nom-demande { background: transparent; border: 0; padding: 4px 0; text-align: left; color: var(--admin-primaire); font: inherit; font-weight: 650; text-decoration: underline; text-underline-offset: 3px; cursor: pointer; }
.admin__conversation-outils { display: flex; align-items: end; gap: 16px; border-bottom: 1px solid var(--admin-ligne); }
.admin__conversation-outils .admin__champ { flex: 1; min-width: 0; }
.admin__conversation-outils select { max-width: 100%; text-overflow: ellipsis; }
.admin__import { padding: 22px 28px; border-top: 1px solid var(--admin-ligne); }
.admin__import summary, .admin__journal summary { cursor: pointer; font-weight: 650; }
.admin__import form { max-width: 640px; padding-top: 12px; }
.admin__import form > * + * { margin-top: 16px; }
.admin__confirmation-demo { display: flex; align-items: start; gap: 12px; padding: 16px; margin-bottom: 22px; background: #fff3dc; border-radius: 10px; }
.admin__confirmation-demo input { flex: 0 0 auto; margin-top: 4px; width: 20px; height: 20px; }
.admin__calendrier-statut { padding: 0 24px 20px; color: #6f5d76; }
.admin__calendrier { display: grid; grid-template-columns: repeat(7, minmax(0, 1fr)); border-top: 1px solid #e6e0e8; }
.admin__jour { min-width: 0; padding: 14px 8px; border-right: 1px solid #e6e0e8; min-height: 260px; }
.admin__jour:last-child { border-right: 0; }
.admin__jour h2 { font-size: 13px; margin: 0 0 18px; text-transform: capitalize; }
.admin__jour--aujourdhui { background: #f8f4f9; }
.admin__jour .admin__note { font-size: 12px; }
.admin__evenement { width: 100%; display: flex; flex-direction: column; text-align: left; gap: 5px; border: 1px solid #c7dacd; border-left: 3px solid #28744a; border-radius: 7px; background: #f5f0f7; color: #233b2d; padding: 10px 8px; margin-bottom: 10px; overflow-wrap: anywhere; font: inherit; font-size: 12px; }
button.admin__evenement { cursor: pointer; }
button.admin__evenement:hover { background: #d7ebdc; }
.admin__evenement--provisoire, .admin__evenement--en_attente { border-color: #d4b45f; background: #fff7e4; color: #604913; }
.admin__evenement--bloquee { background: #f3ecf5; border-color: #beaec4; color: #4d4152; }
.admin__fiche { width: min(760px, calc(100vw - 32px)); max-width: 760px; padding: 0; }
.admin__fiche h3 { margin: 20px 0 12px; }
.admin__renseignements { display: grid; grid-template-columns: minmax(100px, 1fr) minmax(0, 2fr); gap: 12px 18px; margin: 22px 0; }
.admin__renseignement { display: contents; }
.admin__renseignements dt { color: #6f5d76; }
.admin__renseignements dd { margin: 0; overflow-wrap: anywhere; }
.admin__ligne-paiement { display: flex; gap: 12px; justify-content: space-between; flex-wrap: wrap; padding: 12px 0; border-bottom: 1px solid #e6e0e8; }
.admin__fiche-actions { padding: 24px 0; }
.admin__annulation { margin: 22px 0; padding: 18px; background: #fff5f0; border: 1px solid #e6c6b8; border-radius: 12px; }
.admin__operation-paiement { margin: 12px 0; padding: 14px; border: 1px solid #e6e0e8; border-radius: 10px; background: #f9f6fa; }
.admin__operation-paiement p { margin-bottom: 0; }
.admin__journal { border-top: 1px solid #e6e0e8; padding-top: 18px; }
.admin__journal li { padding: 6px 0; font-size: 13px; }
@media (max-width: 1100px) { .admin__calendrier { grid-template-columns: repeat(2, minmax(0, 1fr)); } .admin__jour { min-height: 150px; border-bottom: 1px solid #e6e0e8; } }
@media (max-width: 600px) { .admin__calendrier { grid-template-columns: 1fr; } .admin__jour { border-right: 0; min-height: 110px; padding: 16px; } .admin__conversation-outils { align-items: stretch; flex-direction: column; } .admin__renseignements { grid-template-columns: 1fr; gap: 4px; } .admin__renseignements dd { margin-bottom: 12px; } .admin__import { padding: 18px; } }
@media (prefers-reduced-motion: reduce) {
  * {
    scroll-behavior: auto !important;
  }
}
/* Portail : hiérarchie calme, contrôles cohérents, détails progressifs. */
:root { --admin-encre:#2a1632; --admin-doux:#6b5a70; --admin-fond:#f7f3f9; --admin-ligne:#ece2f0; --admin-primaire:#391d44; --admin-fonce:#2a1632; --admin-accent:#f7f2fa; }
body { font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif; font-size:14px; line-height:1.5; -webkit-font-smoothing:antialiased; }
button { min-height:44px; border-radius:10px; font-weight:500; }
button:focus-visible,a:focus-visible,summary:focus-visible,input:focus-visible,select:focus-visible,textarea:focus-visible,[tabindex]:focus-visible { outline:3px solid #b6b7ea; outline-offset:3px; }
.admin__primaire { background:var(--admin-primaire); border:1px solid transparent; color:white; box-shadow:none; border-radius:999px; padding:10px 19px; font-weight:550; }
.admin__primaire:hover:not(:disabled) { background:#2a1632; box-shadow:0 2px 7px #391d4426; }
.admin__secondaire { color:var(--admin-encre); background:white; border:1px solid #ded6e1; box-shadow:0 1px 2px #00000003; padding:10px 17px; }
.admin__secondaire:hover:not(:disabled) { background:#faf7fb; border-color:#c3b4c8; }
.admin__danger { background:#fff; border:1px solid #e8cbca; color:#bc2b25; }
.admin__danger:hover:not(:disabled) { background:#fff3f2; }
.admin__texte-bouton { color:var(--admin-primaire); font-weight:500; }
.admin__champ input:not([type="checkbox"]):not([type="radio"]), .admin__champ select, .admin__champ textarea { min-height:44px; border:1px solid #d9cfdc; border-radius:10px; padding:10px 13px; background:#fff; color:var(--admin-encre); font-size:14px; box-shadow:0 1px 2px #00000002; }
.admin__champ label { font-weight:500; color:#493d4e; font-size:13px; margin-bottom:7px; }
.admin__champ textarea { min-height:100px; resize:vertical; }
input[type="checkbox"],input[type="radio"] { accent-color:var(--admin-primaire); }
.ux-app { grid-template-columns:224px minmax(0,1fr); background:var(--admin-fond); }
.ux-app .admin__lateral { align-items:stretch; padding:26px 14px 18px; background:#fcfbfd; border-right:1px solid #eee4f1; z-index:25; }
.ux-marque { display:flex; align-items:center; gap:10px; margin:0 12px 29px; text-decoration:none; color:var(--admin-encre); }
.ux-symbole { display:grid; place-items:center; width:32px; height:36px; border-radius:10px; background:#2a1632; color:#fff; }
.ux-symbole svg { width:24px; height:24px; }
.ux-marque strong { font-size:23px; letter-spacing:-.7px; line-height:1.2; }
.ux-marque strong span { display:block; margin-top:4px; font-size:11px; font-weight:450; color:#6b5a70; letter-spacing:0; }
.ux-organisation { display:flex; align-items:center; gap:10px; margin:0 5px 27px; padding:12px 8px; border-top:1px solid #eee6f2; border-bottom:1px solid #eee6f2; min-width:0; }
.ux-organisation div { min-width:0; }
.ux-organisation strong { display:block; font-size:12px; font-weight:600; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.ux-organisation small { display:block; font-size:11px; color:var(--admin-doux); margin-top:3px; }
.admin__avatar { background:#f0e8f3; color:#5d4d63; border:0; border-radius:10px; width:33px; height:33px; font-size:12px; flex-shrink:0; }
.admin__avatar--petit { border-radius:50%; background:#f3ebf7; color:#391d44; }
.ux-nav-groupe { display:flex; flex-direction:column; gap:4px; }
.ux-nav-groupe + .ux-nav-groupe { margin-top:29px; }
.ux-nav-label { color:#6b5a70; font-size:11px; font-weight:550; letter-spacing:.5px; text-transform:uppercase; padding:0 14px 8px; }
.admin__navigation { display:flex; flex-direction:column; gap:0; overflow:visible; margin:0; padding:0; }
.admin__navigation button { display:flex; flex-direction:row; justify-content:flex-start; text-align:left; width:100%; white-space:normal; color:#6f5d77; font-size:13px; gap:12px; border:1px solid transparent; min-height:42px; padding:10px 13px; border-radius:9px; }
.admin__navigation button svg { width:18px; height:18px; }
.admin__navigation button:hover { background:#f3ecf5; color:#2a1632; }
.admin__navigation button[aria-current="page"] { background:#fff; color:var(--admin-encre); font-weight:600; border-color:#ebe1f0; box-shadow:0 2px 4px #00000003; }
.admin__navigation button[aria-current="page"] svg { color:var(--admin-primaire); }
.ux-badge { margin-left:auto; color:#725f79; background:#f0e8f3; min-width:20px; line-height:20px; border-radius:6px; font-size:11px; text-align:center; }
.ux-sidebar-bottom { margin-top:auto; padding:20px 6px 0; }
.ux-assistant-lien { width:100%; justify-content:flex-start; text-align:left; gap:10px; background:transparent; padding:15px 6px; color:#5d4d63; border-top:1px solid #ece2f0; border-radius:0; }
.ux-assistant-lien>span { flex:1; font-size:11px; font-weight:550; }
.ux-assistant-lien small { display:block; font-size:11px; font-weight:400; color:#6b5a70; margin-top:3px; }
.ux-assistant-lien>svg:first-child { color:#391d44; }
.ux-site-lien { display:flex; align-items:center; justify-content:space-between; font-size:11px; color:#7e6a86; text-decoration:none; padding:12px 6px; }
.ux-statut-connexion { display:flex; align-items:center; gap:6px; font-size:11px; color:#6b5a70; padding:15px 6px 0; }
.admin__point { background:#69a585; width:5px; height:5px; }
.ux-app .admin__barre { display:flex; height:66px; min-height:66px; padding:0 40px; border-bottom:1px solid #eee6f2; background:#ffffffd9; backdrop-filter:blur(18px); gap:15px; position:sticky; top:0; z-index:15; }
.ux-breadcrumb { display:flex; align-items:center; gap:13px; font-size:11px; color:#6b5a70; min-width:0; }
.ux-breadcrumb>span { max-width:220px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.ux-breadcrumb>strong { color:#6e5c76; font-weight:500; white-space:nowrap; }
.ux-breadcrumb svg { color:#6b5a70; }
.ux-header-outils { display:flex; align-items:center; gap:20px; margin-left:auto; }
.ux-recherche-bouton { color:#6b5a70; font-size:11px; padding:4px 0; background:transparent; gap:8px; min-height:36px; }
.ux-recherche-bouton kbd { background:#f7f3f9; border:1px solid #ede3f1; border-radius:4px; padding:1px 5px; margin-left:15px; color:#6b5a70; font-family:inherit; font-size:11px; }
.ux-compte { position:relative; }
.ux-compte summary { list-style:none; cursor:pointer; display:flex; align-items:center; min-height:44px; }
.ux-compte summary::-webkit-details-marker { display:none; }
.ux-compte-menu { position:absolute; right:0; top:50px; z-index:30; padding:18px; min-width:230px; border-radius:14px; border:1px solid #ece2f0; background:#fff; box-shadow:0 10px 40px #00000014; }
.ux-compte-menu>strong,.ux-compte-menu>small { display:block; font-size:13px; overflow-wrap:anywhere; }
.ux-compte-menu>small { margin:5px 0 12px; color:var(--admin-doux); font-size:12px; }
.ux-compte-menu button { width:100%; justify-content:flex-start; border-top:1px solid #ece2f0; border-radius:0; background:white; margin-top:10px; padding:12px 0 0; font-size:12px; }
.ux-compte-menu p { margin:10px 0 0; font-size:12px; }
.ux-compte-organisations { display:grid; margin:4px 0 6px; }
.ux-compte-organisations>small { color:var(--admin-doux); font-size:11px; letter-spacing:.04em; text-transform:uppercase; }
.ux-compte-organisations button { margin-top:8px; padding-top:8px; text-align:left; color:var(--admin-encre, #2a1632); }
.ux-compte-organisations button[aria-current] { font-weight:700; cursor:default; }
.ux-menu-bouton,.ux-voile { display:none; }
.ux-app .admin__contenu { padding:34px 40px 18px; max-width:1440px; width:100%; margin:0 auto; }
.ux-page-entete { display:flex; justify-content:space-between; align-items:center; gap:24px; margin-bottom:28px; }
.ux-page-entete h1 { font-size:32px; line-height:1.2; font-weight:650; letter-spacing:-1.15px; margin:0 0 9px; }
.ux-page-entete h1:focus { outline:none; }
.ux-page-entete p { font-size:13px; color:#6b5a70; margin:0; }
.ux-page-entete p.ux-date { font-size:11px; letter-spacing:.8px; font-weight:500; text-transform:uppercase; margin-bottom:12px; color:#6b5a70; }
.ux-page-entete>.admin__primaire { flex-shrink:0; font-size:12px; min-height:41px; }
.ux-mode-demo { background:transparent; border-top:1px solid #ece2f0; border-bottom:1px solid #ece2f0; padding:10px 0; margin-bottom:26px; }
.ux-mode-demo summary { display:flex; align-items:center; gap:8px; font-size:11px; cursor:pointer; list-style:none; color:#6b5a70; }
.ux-mode-demo summary::-webkit-details-marker { display:none; }
.ux-mode-demo summary strong { font-weight:500; color:#6b5a70; }
.ux-mode-demo summary>svg { margin-left:auto; transform:rotate(90deg); }
.ux-mode-demo[open] summary>svg { transform:rotate(-90deg); }
.ux-mode-demo p { font-size:12px; padding-left:14px; margin:12px 0 0; color:#826c8a; }
.ux-demo-point { width:5px; height:5px; border-radius:50%; background:#c6a36b; flex-shrink:0; }
.ux-resume { display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); gap:18px; margin-bottom:28px; }
.ux-resume .admin__stat { background:transparent; box-shadow:none; padding:0 20px 0 0; border:0; border-right:1px solid #e6e0e9; border-radius:0; gap:8px; min-height:94px; text-align:left; align-items:flex-start; }
.ux-resume .admin__stat:last-child { border-right:0; }
.ux-resume .admin__stat-titre { font-size:12px; font-weight:500; color:#6b5a70; display:flex; align-items:center; justify-content:space-between; width:100%; }
.ux-resume .admin__stat-titre>svg { width:16px; height:16px; color:#6b5a70; }
.ux-resume .admin__stat>strong { font-size:32px; font-weight:600; letter-spacing:-1px; line-height:1.2; }
.ux-resume .admin__stat>small { font-size:11px; color:#6b5a70; }
.ux-resume .admin__stat>small>svg { opacity:0; width:13px; }
.ux-resume .admin__stat:hover>small>svg { opacity:1; color:var(--admin-primaire); }
.admin__panneau { background:white; border:1px solid #ebe1f0; border-radius:16px; box-shadow:0 2px 5px #00000002; overflow:hidden; }
.admin__section-entete { padding:23px 25px; border-bottom:1px solid #f3ecf5; gap:16px; }
.admin__section-entete h2 { font-size:16px; letter-spacing:-.35px; font-weight:600; color:var(--admin-encre); margin:0; }
.admin__section-entete p { font-size:11px; margin:5px 0 0; color:#6b5a70; }
.admin__section-entete .admin__texte-bouton { font-size:11px; min-height:32px; padding:4px 0; flex-shrink:0; }
.admin__section { padding:24px; }
.ux-accueil-grille { display:grid; grid-template-columns:minmax(0,1fr) 268px; gap:22px; margin-bottom:26px; }
.ux-liste-evenements { padding:0 22px; }
.ux-evenement-ligne { width:100%; background:#fff; text-align:left; display:flex; align-items:center; gap:14px; border:0; border-bottom:1px solid #f4eef6; border-radius:0; min-height:103px; padding:18px 0; }
.ux-evenement-ligne:last-child { border-bottom:0; }
.ux-evenement-ligne:hover .ux-evenement-description strong { color:var(--admin-primaire); }
.ux-evenement-ligne>svg { color:#6b5a70; }
.ux-vignette { width:51px; height:56px; border-radius:12px; background:linear-gradient(145deg,#f6f1fa,#f2e9f7); color:#6b5a70; display:grid; place-items:center; flex-shrink:0; }
.ux-vignette--1 { background:linear-gradient(145deg,#f5eff7,#eee5f1); color:#6b5a70; }
.ux-vignette--2 { background:linear-gradient(145deg,#f7f1ea,#eee5da); color:#b29e80; }
.ux-evenement-description { flex:1; min-width:0; }
.ux-evenement-description strong { display:block; font-size:13px; font-weight:550; letter-spacing:-.15px; }
.ux-evenement-description small { display:block; margin-top:5px; font-size:11px; color:#6b5a70; font-weight:400; }
.ux-etat-publication { padding:4px 8px; background:#f6f1f8; color:#6b5a70; font-size:11px; font-weight:500; border-radius:5px; flex-shrink:0; }
.ux-etat-publication--ouvert { color:#3b7053; background:#f7f3f9; }
.ux-prochaine-etape { border:1px solid #ece2f0; border-radius:16px; background:linear-gradient(145deg,#f9f6fb,#f6f1fa); padding:24px; display:flex; flex-direction:column; align-items:flex-start; }
.ux-icone-douce { width:42px; height:42px; border-radius:12px; display:inline-grid; place-items:center; background:#f5f0f9; color:#391d44; flex-shrink:0; }
.ux-prochaine-etape .ux-icone-douce { background:#f2e9f7; color:#391d44; margin-bottom:25px; }
.ux-surtitle { font-size:11px; letter-spacing:1px; font-weight:550; color:#7f6a88; margin-bottom:9px; }
.ux-prochaine-etape h2 { font-size:21px; line-height:1.3; letter-spacing:-.5px; font-weight:600; margin:0 0 12px; }
.ux-prochaine-etape>p:not(.ux-surtitle) { font-size:11px; color:#391d44; line-height:1.7; margin-bottom:25px; }
.ux-prochaine-etape>button { margin-top:auto; font-size:11px; min-height:37px; background:#fff9; padding:9px 13px; border-color:#ebdef3; width:100%; }
.admin__table { font-size:12px; }
.admin__table th { background:#fbf9fc; font-size:11px; text-transform:uppercase; letter-spacing:.6px; color:#6b5a70; font-weight:500; padding:13px 24px; border-bottom:1px solid #f3ecf5; }
.admin__table tbody tr:hover { background:#fbfafc; }
.admin__table td { padding:18px 24px; border-bottom:1px solid #f5f0f7; color:#615167; }
.admin__table td strong { font-size:11px; font-weight:500; }
.admin__table small { color:#6b5a70; font-size:11px; margin-top:4px; }
.admin__nom-demande { font-size:12px; min-height:24px; font-weight:550; text-decoration:none; color:#433847; }
.admin__nom-demande:hover { color:var(--admin-primaire); text-decoration:underline; }
.admin__etat { border:0; padding:4px 8px; border-radius:5px; font-size:11px; background:#f6f1f8; color:#6b5a70; font-weight:500; }
.admin__etat::before { width:4px; height:4px; }
.admin__etat--confirmee { background:#f7f3f9; color:#6b5a70; }
.admin__etat--en_attente_approbation { background:#fff7e8; color:#a68242; }
.admin__etat--en_attente_paiement { background:#f6f1fa; color:#391d44; }
.admin__etat--annulee,.admin__etat--refusee,.admin__etat--expiree { background:#f6f1f8; color:#6b5a70; }
.ux-vue-barre { display:flex; align-items:center; justify-content:space-between; margin-bottom:22px; gap:15px; }
.ux-segments { display:inline-flex; background:#f0e8f3; border:1px solid #ece1f0; padding:3px; border-radius:10px; gap:3px; }
.ux-segments button { background:transparent; border:1px solid transparent; color:#6b5a70; min-height:34px; border-radius:7px; padding:6px 14px; font-size:12px; }
.ux-segments button[aria-pressed="true"] { background:#fff; color:#3e3442; box-shadow:0 1px 4px #0000000b; border-color:#eee6f2; }
.ux-caption { font-size:11px; color:#6b5a70; }
.admin__filtres { align-items:end; gap:18px; }
.admin__resultat-filtre { margin-top:16px; font-size:11px; color:#6b5a70; }
.admin__calendrier-statut { color:#6b5a70; font-size:11px; }
.admin__jour { border-color:#eee6f2; padding:16px 10px; }
.admin__jour h2 { font-size:11px; font-weight:550; color:#725f79; }
.admin__jour--aujourdhui { background:#fbf9fd; }
.admin__jour .admin__note { color:#6b5a70; font-size:11px; }
.admin__evenement { background:#f7f2fa; border-color:#ece0f3; border-left-color:#9a9ce2; border-radius:6px; color:#391d44; font-size:11px; }
button.admin__evenement:hover { background:#f3ecf8; }
.admin__evenement--en_attente,.admin__evenement--provisoire { background:#fff8eb; border-color:#eed7a7; color:#947743; }
.admin__evenement--bloquee { background:#f6f2f8; border-color:#dfd7e2; color:#6b5a70; }
.ux-reglages { display:grid; grid-template-columns:minmax(250px,.8fr) minmax(0,1.2fr); gap:25px; align-items:start; }
.ux-fiche-organisation { display:grid; grid-template-columns:1fr; gap:6px; padding:24px; margin:0; }
.ux-fiche-organisation dt { font-size:11px; color:#6b5a70; }
.ux-fiche-organisation dd { font-size:13px; color:#4e4153; margin:0 0 19px; overflow-wrap:anywhere; }
.ux-reglage-ligne { display:flex; text-align:left; align-items:center; gap:16px; padding:21px 25px; width:100%; border-radius:0; background:white; border-bottom:1px solid #f4eef6; }
.ux-reglage-ligne:last-child { border-bottom:0; }
.ux-reglage-ligne>span:nth-child(2) { flex:1; }
.ux-reglage-ligne strong { display:block; font-size:13px; font-weight:550; }
.ux-reglage-ligne small { display:block; font-size:11px; color:#6b5a70; margin-top:5px; line-height:1.55; }
.ux-reglage-ligne>svg { color:#6b5a70; }
.ux-reglage-ligne:hover { background:#fdfcfe; }
.ux-conversation-select { display:flex; align-items:center; gap:12px; border-bottom:1px solid #f3ecf5; }
.ux-conversation-select label { color:#6b5a70; font-size:11px; }
.ux-conversation-select select { max-width:500px; min-width:0; flex:1; min-height:36px; border:1px solid #e4dde7; border-radius:8px; background:#fff; font-size:12px; padding:5px 10px; }
.admin__bulle { border-radius:16px; font-size:13px; }
.admin__bulle--responsable { background:#f7f2fa; color:#391d44; border-color:#f1e9f7; }
.admin__bulle--assistant { background:#f9f6fa; border-color:#f3edf6; }
.admin__bienvenue-assistant h2 { font-size:25px; font-weight:600; letter-spacing:-.5px; }
.admin__bienvenue-assistant p { font-size:13px; color:#6b5a70; }
.admin__icone-service { background:#f6f0f9; color:#6b5a70; border-color:#f2eaf7; border-radius:13px; }
.admin__compositeur { border-top:1px solid #f3ecf5; background:#fff; padding:20px 25px; }
.admin__compositeur textarea { border:1px solid #e0d8e3; border-radius:13px; background:#fbf9fc; font-size:13px; }
.admin__dialogue { border:1px solid #ede3f1; border-radius:20px; color:var(--admin-encre); box-shadow:0 30px 120px #2a163233; }
.admin__dialogue::backdrop,.ux-recherche::backdrop { background:#2a16324d; backdrop-filter:blur(6px); }
.admin__dialogue h2 { letter-spacing:-.65px; font-weight:600; }
.admin__fiche { max-width:780px; }
.admin__fiche .admin__section-entete { position:sticky; top:0; background:#fffffff2; backdrop-filter:blur(15px); z-index:2; }
.admin__fiche .admin__section-entete h2 { font-size:20px; margin-right:auto; }
.admin__fiche h3 { font-size:16px; font-weight:550; }
.admin__renseignements { font-size:13px; gap:12px 20px; }
.admin__renseignements dt { color:#6b5a70; }
.admin__renseignements dd { color:#4c4051; }
.admin__ligne-paiement { font-size:12px; border-color:#f4edf6; }
.admin__operation-paiement { background:#fbf9fd; border-color:#f0e6f6; font-size:12px; }
.admin__annulation { background:#fffafa; border-color:#f0dddd; }
.admin__journal { border-color:#efe7f2; color:#6b5a70; font-size:12px; }
.admin__journal li { font-size:11px; }
.admin__confirmation-demo { background:#f9f6fa; font-size:12px; color:#6b5a70; padding:15px; border:1px solid #eee5f1; }
.ux-decision-fiche { background:#faf7fc; border:1px solid #f0e6f6; border-radius:13px; padding:20px; margin:20px 0; }
.ux-decision-fiche h3 { margin:0 0 7px; font-size:14px; }
.ux-decision-fiche p { font-size:12px; color:#6b5a70; margin-bottom:18px; }
.ux-confirmation { max-width:460px; padding:30px; }
.ux-confirmation h2 { margin:20px 0 10px; font-size:23px; line-height:1.3; }
.ux-confirmation p { color:#6b5a70; font-size:13px; }
.ux-confirmation p.ux-confirmation-nom { font-weight:550; color:#55475a; }
.ux-confirmation .admin__actions { margin-top:25px; justify-content:flex-end; }
.ux-toast { position:fixed; bottom:28px; left:calc(50% + 110px); transform:translateX(-50%); z-index:100; max-width:calc(100vw - 32px); }
.ux-toast>span { display:flex; align-items:center; gap:12px; padding:11px 12px 11px 18px; border-radius:13px; border:1px solid #e6e0e8; background:#fffffff2; backdrop-filter:blur(15px); box-shadow:0 10px 40px #00000012; color:#605167; font-size:12px; }
.ux-toast>span>svg { color:#548967; }
.ux-toast button { min-height:26px; padding:5px; color:#6b5a70; background:transparent; }
.ux-recherche { padding:0; width:min(600px,calc(100vw - 32px)); max-height:75vh; border-radius:18px; border:1px solid #ebe0ef; box-shadow:0 30px 120px #2a163233; margin-top:15vh; overflow:hidden; color:var(--admin-encre); }
.ux-recherche-champ { display:flex; align-items:center; padding:15px 19px; gap:12px; border-bottom:1px solid #f2ebf5; color:#6b5a70; }
.ux-recherche-champ input { flex:1; min-width:0; border:0; font-size:15px; padding:8px 0; color:#56485c; background:white; outline:none; }
.ux-recherche-champ button { background:transparent; padding:3px; min-height:28px; color:#6b5a70; }
.ux-recherche kbd { font:10px inherit; border:1px solid #e5dfe8; border-radius:4px; padding:2px 5px; }
.ux-recherche-resultats { padding:12px; max-height:52vh; overflow:auto; }
.ux-recherche-resultats h2 { font-size:11px; text-transform:uppercase; letter-spacing:.6px; color:#6b5a70; font-weight:500; padding:13px 9px 7px; margin:0; }
.ux-recherche-resultats>button { display:flex; align-items:center; width:100%; padding:12px; gap:12px; background:white; font-size:13px; color:#725f79; text-align:left; border-radius:8px; }
.ux-recherche-resultats>button>span { flex:1; }
.ux-recherche-resultats>button small { display:block; color:#6b5a70; font-size:11px; margin-top:4px; }
.ux-recherche-resultats>button>svg { width:17px; color:#6b5a70; }
.ux-recherche-resultats>button:hover,.ux-recherche-resultats>button:focus { background:#f7f3fa; color:#391d44; outline:none; }
.ux-recherche footer { font-size:11px; padding:12px 22px; color:#6b5a70; border-top:1px solid #f2ebf5; }
.ux-recherche-vide { padding:22px; text-align:center; }
.ux-recherche-vide h2 { font-size:15px; text-transform:none; letter-spacing:0; color:#7d6985; }
.ux-recherche-vide p { margin:8px 0 18px; color:#6b5a70; font-size:12px; }
.ux-footer { display:flex; align-items:center; justify-content:space-between; color:#6b5a70; font-size:11px; border-top:1px solid #ede3f1; margin-top:35px; padding:18px 0 0; }
.ux-footer span:first-child { font-weight:550; color:#6b5a70; }
.admin__vide { padding:45px 25px; }
.admin__vide h3 { font-size:17px; font-weight:550; letter-spacing:-.3px; }
.admin__vide p { font-size:12px; color:#6b5a70; max-width:380px; margin-left:auto; margin-right:auto; }
.admin__vide .admin__icone-service { margin-bottom:20px; }
.admin__connexion { width:min(440px,calc(100% - 32px)); background:white; margin:12vh auto; border:1px solid #ece2f0; box-shadow:0 10px 50px #00000004; border-radius:22px; padding:36px; }
.admin__connexion h1 { font-size:28px; line-height:1.2; letter-spacing:-.8px; margin:18px 0 14px; }
.admin__connexion p { font-size:13px; color:#6b5a70; }
.admin__connexion .admin__primaire { width:100%; margin-top:20px; }
.ux-brand { font-size:22px; letter-spacing:-.7px; font-weight:650; color:#3a303e; }
.ux-skeleton { display:grid; grid-template-columns:repeat(3,1fr); gap:20px; padding-top:10px; }
.ux-skeleton>span { height:110px; border-radius:14px; background:linear-gradient(90deg,#f3ecf5,#fbf8fc,#f3ecf5); background-size:200% 100%; animation:ux-shimmer 1.7s infinite; }
.ux-skeleton>div { grid-column:1/-1; height:330px; border-radius:16px; border:1px solid #eee4f1; background:#fbfafc; }
@keyframes ux-shimmer { to { background-position:-200% 0; } }
@media(min-width:1600px) { .ux-app .admin__contenu { padding-top:45px; } }
@media(max-width:1200px) { .ux-app { grid-template-columns:205px minmax(0,1fr); } .ux-app .admin__contenu { padding:30px 28px 18px; } .ux-app .admin__barre { padding:0 28px; } .ux-accueil-grille { grid-template-columns:minmax(0,1fr) 235px; gap:18px; } .ux-prochaine-etape { padding:20px; } .ux-evenement-description strong { font-size:12px; } .ux-etat-publication { display:none; } .ux-breadcrumb>span { max-width:150px; } }
@media(max-width:1000px) { .ux-accueil-grille { grid-template-columns:minmax(0,1fr); } .ux-prochaine-etape { display:none; } .ux-reglages { grid-template-columns:1fr; } .ux-resume { gap:18px; } .ux-resume .admin__stat>small { font-size:11px; } }
@media(max-width:860px) { .ux-app { display:block; } .ux-app .admin__lateral { position:fixed; left:0; top:0; bottom:0; height:100dvh; width:240px; display:flex; transform:translateX(-100%); visibility:hidden; transition:transform .2s ease,visibility .2s; z-index:45; } .ux-app--menu .admin__lateral { transform:translateX(0); visibility:visible; } .ux-app--menu .ux-voile { position:fixed; inset:0; z-index:40; background:#2a163244; backdrop-filter:blur(3px); display:block; width:100%; height:100dvh; border:0; border-radius:0; } .ux-menu-bouton { display:inline-flex; background:transparent; color:#6b5a70; min-height:36px; padding:6px; margin-left:-6px; } .ux-menu-bouton svg { color:#6b5a70; } .ux-app .admin__barre { height:60px; min-height:60px; padding:0 25px; } .ux-breadcrumb { font-size:11px; gap:10px; } .ux-breadcrumb>span { display:none; } .ux-breadcrumb>svg { display:none; } .ux-toast { left:50%; } .ux-header-outils { gap:18px; } .ux-resume .admin__stat>small { font-size:11px; } }
@media(max-width:600px) { .ux-app .admin__contenu { padding:25px 18px 15px; } .ux-app .admin__barre { padding:0 18px; } .ux-page-entete { align-items:flex-start; flex-direction:column; gap:19px; margin-bottom:24px; } .ux-page-entete h1 { font-size:29px; letter-spacing:-.9px; } .ux-page-entete p { font-size:12px; } .ux-page-entete>.admin__primaire { width:100%; min-height:44px; } .ux-recherche-bouton>span,.ux-recherche-bouton kbd { display:none; } .ux-header-outils { gap:17px; } .ux-mode-demo { margin-bottom:25px; padding:11px 0; } .ux-mode-demo summary>span:not(.ux-demo-point) { display:none; } .ux-resume { gap:13px; margin-bottom:25px; } .ux-resume .admin__stat { padding-right:10px; gap:7px; min-height:86px; } .ux-resume .admin__stat-titre { font-size:11px; } .ux-resume .admin__stat-titre svg { display:none; } .ux-resume .admin__stat>strong { font-size:28px; } .ux-resume .admin__stat>small { font-size:11px; line-height:1.5; } .admin__section-entete { padding:20px; } .admin__section-entete h2 { font-size:15px; } .admin__section-entete p { font-size:11px; } .ux-liste-evenements { padding:0 18px; } .ux-evenement-ligne { gap:12px; min-height:93px; } .ux-vignette { width:42px; height:49px; border-radius:10px; } .ux-vignette svg { width:20px; } .ux-evenement-description strong { font-size:12px; } .ux-evenement-description small { font-size:11px; } .ux-evenement-ligne>svg { width:13px; } .ux-reglage-ligne { padding:19px; gap:12px; } .ux-reglage-ligne .ux-icone-douce { width:36px; height:36px; border-radius:10px; } .admin__table th { padding:12px 17px; } .admin__table td { padding:16px 17px; } .admin__section { padding:20px; } .ux-caption { font-size:11px; } .ux-vue-barre { gap:10px; } .ux-segments button { padding:6px 10px; font-size:11px; } .admin__champ input:not([type="checkbox"]):not([type="radio"]),.admin__champ select,.admin__champ textarea { font-size:16px; } .admin__filtres { gap:15px; } .ux-footer { font-size:11px; } .admin__fiche { width:calc(100vw - 20px); } .admin__fiche .admin__section-entete { padding:16px; flex-wrap:wrap; } .admin__fiche .admin__section-entete h2 { font-size:18px; } .admin__fiche .admin__section-entete button { font-size:11px; padding:6px 10px; min-height:35px; } .admin__fiche h3 { font-size:16px; } .admin__renseignements { font-size:13px; } .ux-confirmation { padding:25px; } .ux-recherche { margin-top:9vh; } .ux-recherche-champ { padding:12px; gap:8px; } .ux-recherche-champ input { font-size:14px; } .ux-conversation-select { padding:15px; } .admin__compositeur { padding:15px; } .admin__compositeur textarea { font-size:16px; } .ux-toast>span { font-size:11px; } .admin__connexion { padding:30px 25px; } }
.ux-page-entete>.admin__primaire { font-size:14px; min-height:44px; }
.admin__navigation button { font-size:14px; min-height:44px; }
.admin__table { font-size:13px; }
.admin__table th,.admin__table small { font-size:12px; }
.admin__table td strong,.admin__nom-demande { font-size:13px; }
.ux-evenement-description strong { font-size:14px; }
.ux-evenement-description small { font-size:12px; }
@media(max-width:600px) { .ux-resume { gap:10px; } .ux-resume .admin__stat>small { font-size:11px; } .ux-resume .admin__stat-titre { font-size:12px; } .ux-evenement-description strong { font-size:13px; } }
@media(max-width:600px) {
.admin__table-wrap { overflow:visible; }
.admin__table { display:block; min-width:0; width:100%; }
.admin__table thead { position:absolute; width:1px; height:1px; padding:0; margin:-1px; overflow:hidden; clip:rect(0,0,0,0); white-space:nowrap; }
.admin__table tbody { display:block; }
.admin__table tbody tr { display:grid; grid-template-columns:minmax(0,1fr); gap:12px; padding:20px; border-bottom:1px solid #efe7f3; }
.admin__table tbody tr:last-child { border-bottom:0; }
.admin__table td { display:block; padding:0; border:0; }
.admin__table td strong { font-size:13px; }
.admin__table .admin__nom-demande { font-size:15px; padding:3px 0; min-height:30px; }
.admin__table small { margin-top:4px; overflow-wrap:anywhere; }
.admin__table td:has(>.admin__note) { display:none; }
.admin__table .admin__actions { justify-content:flex-start; flex-wrap:wrap; }
.admin__table .admin__actions button { min-height:44px; font-size:13px; padding:10px 18px; }
}
@media(prefers-reduced-motion:reduce) { .ux-skeleton>span { animation:none; } .ux-app .admin__lateral { transition:none; } }

.ux-nav-entree>button{width:100%}.ux-nav-enfants{margin:4px 0 8px 27px;padding-left:12px;border-left:1px solid #ebdff3}.admin__navigation .ux-nav-enfants button{font-size:12px;min-height:35px;padding:7px 9px;border:0;background:transparent;color:#6b5a70;width:100%;text-align:left}.admin__navigation .ux-nav-enfants button[aria-current]{color:#391d44;background:#f7f2fa;border-radius:7px;font-weight:500}.ux-nav-groupe{min-width:0}.admin__navigation .ux-nav-entree>button>span{white-space:nowrap}
`
export function installerStylesAdmin(): void {
  if (document.querySelector('style[data-funo-admin-styles]')) return
  const style = document.createElement('style')
  style.dataset.funoAdminStyles = ''
  style.textContent = CSS_ADMIN + stylesAcces + stylesEvenements + CSS_BRAND_ADMIN + CSS_DEMO_EASTER_EGG
  document.head.append(style)
}
